<template lang="html">
  <div>
    <navigation-bar/>
    <h1>Integrate here</h1>
    <router-link :to="{name: 'Test Widget', params: {company_id: user.fb_data.companyId } }">
      Access your {{user.fb_data.company}} call widget here
    </router-link>

  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import NavigationBar from './NavigationBar.vue'

export default {
  components: {
    'navigation-bar': NavigationBar
  },
  computed: {
    ...mapGetters({
      'user': 'user',
    }),
  }


}
</script>

<style lang="css" scoped>
</style>
